import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as costIt } from "./i18n/cost.lang-it";
import costSettingsLinks from "./cost.settings-list";
import { RouterModule } from "@angular/router";
import costRoutes from "./cost.routes";
import costMenu from "./cost.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbDatepickerModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProvidersCostListComponent } from "./pages/providers-cost/providers-cost-list/providers-cost-list.component";
import { StructureCostListComponent } from "./pages/structure-cost/strcture-cost-list/structure-cost-list.component";
import { LayoutModule } from "app/layout/layout.module";

@NgModule({
  declarations: [ProvidersCostListComponent, StructureCostListComponent],
  imports: [
    RouterModule.forChild(costRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    LayoutModule,
  ],
})
export class CostModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("cost", costIt, costMenu, costSettingsLinks);
  }
}
